module.exports = new __parcel__URL__("AudioBriefingChangeboardingIllustration.3bcea83c.svg").toString();